import { ReactNode } from 'react';
import { create } from 'zustand'

interface HeaderText {
    title: string
    heading: ReactNode | null
}


interface HeaderTextStore {
    headerText: HeaderText;
    setHeaderText: (headerText: HeaderText) => void;
}

const useHeaderTextStore = create<HeaderTextStore>()(
    (set) => (
        {
            headerText: {
                title: "Title",
                heading: ("Heading")
            },
            setHeaderText: (headerText) => { set(state => ({ ...state, headerText, })) }
        }
    )
)

export default useHeaderTextStore;